export class BasicResponse{
    
    public success: boolean = false;
    public message: string = '';
    public code?: number;
    public longCode?: number;
    public reference?: string;

    constructor(){
    }
}